window.addEventListener("load", function() {
    const videoPosters = document.querySelectorAll("video[data-poster]");

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Set the high-resolution poster when in view
                entry.target.poster = entry.target.dataset.poster;
                observer.unobserve(entry.target);
            }
        });
    });

    videoPosters.forEach(video => {
        observer.observe(video);
    });
});
